.boldText {
	font-weight: bold !important;
	/* margin-bottom: 10px !important; */
}

.priceInfo {
	font-weight: bold !important;
	margin-top: 20px !important;
}

.priceInfoWithDiscount {
	text-decoration: line-through !important;
	margin-top: 20px !important;
}

.discountInfo {
	font-weight: bold !important;
	margin-top: 2px !important;
}

.productContent {
	width: 100% !important;
	height: 100% !important;
}

.contentSize {
	height: calc(100% - 80%) !important;
	width: 100% !important;
}

.imageSize {
	width: 100% !important;
}
